import { propertyAvailVacTotalRules, propertyVacantBreakdownRules } from './avail-vac-totals.calc.js';
import { propertyRateRules } from './rates.calc.js';
export const propertyRules = [...propertyAvailVacTotalRules, ...propertyVacantBreakdownRules, ...propertyRateRules];
export const propertyRegistry = {
  domain: 'property',
  rules: propertyRules
};
